
export class FileType {

    constructor() {
        this.id = 0
        this.name = ''
        this.extension = []
        this.createdAt = new Date()
        this.updatedAt = new Date()
    }

    supported(ext) {
        let isSupport = false
        this.extension.forEach((item) => {
            if (item === ext) {
                isSupport = true
            }
        })
        return isSupport
    }

    toString(){
        return '/api/files_types/' + this.id
    }
}

export default class Files {
    constructor() {
        this.id = 0
        this.name = ''
        this._path = ''
        this.size = 0
        this.type = new FileType()
        this.online = true
        this.createdAt = new Date()
        this.updatedAt = new Date()
        this.data = []
        this.baseUrl =''
        this.userId = 0
    }

    get path() {
        if (this._path === undefined) {
            return ''
        } else if (this._path.length > 50 || this._path.length === 0) {
            return this._path
        }
        return this.url();
    }

    set path(value) {
        this._path = value;
    }

    url() {
        return this.baseUrl + this._path
    }

    supportedType() {
        if (this.data instanceof File) {
            let type= this.data.type.split('/').splice(-1, 1)[0]
            return this.type.supported(type)
        }
        return false
    }
}

export class FileApp {
    constructor(store) {
        this._store = store;
        this._reader = new FileReader()
    }

    loadingFile(file) {
        this._reader.addEventListener("load", this.createFile.bind(this))
        this._reader.readAsDataURL(file)
    }

    createFile () {
        let file = new Files()
        let url = this._reader.result
        file.path = url
        file.online = true
        this._store.commit('file/SET_TMP_FILE', file)
    }
}

